import { createContext, useContext } from 'react';

import type { SlotId } from './screens/strategySummary';

export type OnboardingTransitionContextValue = {
	completeOnboarding: (pillars: SlotId[]) => void;
	pillarsOverride: SlotId[] | null;
};

export const OnboardingTransitionContext =
	createContext<OnboardingTransitionContextValue | null>(null);

export const useOnboardingTransition = (): OnboardingTransitionContextValue => {
	const ctx = useContext(OnboardingTransitionContext);
	if (!ctx) {
		throw new Error(
			'useOnboardingTransition must be used within an OnboardingTransitionProvider',
		);
	}
	return ctx;
};

export const useOnboardingPillarsOverride = (): SlotId[] | null => {
	const ctx = useContext(OnboardingTransitionContext);
	return ctx?.pillarsOverride ?? null;
};
